var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && !_vm.user.activated)?_c('div',{staticClass:"bg-danger text-center p-2"},[_vm._v("\n  メールアドレスの認証が完了していません。ご登録のメールアドレス宛にお送りしているメールを確認し、認証を完了してください。\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4837ce76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Notice.vue
// module id = b3r8
// module chunks = 53